/** Inline SVG for the Simpl wordmark — used by the 3D loading screen. */
export const SIMPL_LOGO_SVG = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 496 496" enable-background="new 0 0 496 496" xml:space="preserve">
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M119.000221,192.973206 
	C127.161263,192.990982 134.828506,192.820312 142.482010,193.070358 
	C153.930710,193.444412 160.607208,200.823456 160.057312,212.167923 
	C160.002243,213.304337 159.955826,214.637558 159.364807,215.515549 
	C157.424194,218.398407 143.454697,217.223541 142.378357,214.001526 
	C141.456635,211.242294 139.817719,210.403503 137.197403,210.410858 
	C126.371994,210.441269 115.544731,210.530472 104.721718,210.364899 
	C100.052704,210.293488 100.265839,213.218658 100.348366,216.353714 
	C100.430641,219.479324 99.683365,222.818924 104.827415,222.739258 
	C117.148766,222.548492 129.475540,222.661484 141.799805,222.719482 
	C153.480774,222.774460 159.957779,229.299988 160.052063,241.049042 
	C160.085464,245.212097 160.153473,249.382538 159.960297,253.538193 
	C159.520477,262.998993 152.994888,269.284241 143.564972,269.320099 
	C128.742508,269.376465 113.919449,269.277283 99.097038,269.338806 
	C89.081009,269.380402 81.683914,261.074158 83.793427,248.367889 
	C83.820702,248.203598 83.788261,247.985611 83.882217,247.882492 
	C87.279320,244.155182 91.679176,246.511993 95.602470,246.047958 
	C97.712280,245.798431 100.204552,245.915985 100.288643,249.088409 
	C100.377502,252.441147 102.432526,252.609955 105.068817,252.462540 
	C115.546852,251.876617 126.036148,251.809738 136.511688,252.473221 
	C140.568954,252.730209 142.889343,251.687286 142.674622,247.036026 
	C142.498398,243.219330 143.027863,239.895981 137.155716,240.112579 
	C125.347000,240.548141 113.510620,240.279770 101.686005,240.225525 
	C89.820694,240.171097 83.671043,233.909760 83.637886,221.967667 
	C83.625862,217.637466 83.589684,213.306564 83.648010,208.977112 
	C83.757881,200.819641 88.923622,194.895157 97.058060,193.544373 
	C104.177277,192.362167 111.354301,193.222870 119.000221,192.973206 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M209.571594,268.932861 
	C190.286865,269.556763 194.193008,271.169983 193.922318,255.238541 
	C193.687546,241.420029 193.978287,227.592926 193.786118,213.773117 
	C193.725250,209.395126 194.908585,207.565231 199.689484,207.612366 
	C221.669952,207.829132 243.653839,207.669769 265.636322,207.723053 
	C276.767090,207.750015 283.286407,214.332687 283.312286,225.451645 
	C283.342133,238.274734 283.194427,251.099442 283.363220,263.920288 
	C283.416718,267.983795 282.081635,269.514374 277.909882,269.409271 
	C264.584900,269.073486 266.862793,270.780060 266.691406,258.358826 
	C266.562775,249.034576 266.531433,239.704727 266.717224,230.382553 
	C266.791779,226.643616 265.762207,225.042892 261.705627,224.959229 
	C247.293564,224.662003 247.296417,224.531784 247.299561,238.908249 
	C247.301422,247.401505 247.205093,255.896423 247.350601,264.387207 
	C247.411682,267.951202 246.228394,269.480927 242.463608,269.395721 
	C228.142075,269.071442 230.145920,271.179321 230.002213,257.430939 
	C229.906494,248.272476 229.873062,239.111130 229.998810,229.953644 
	C230.048859,226.308365 228.641785,224.905762 224.983093,224.993073 
	C208.151459,225.394669 211.553604,222.930130 211.229309,238.064011 
	C211.050949,246.386932 211.218994,254.716843 211.172272,263.043304 
	C211.161316,264.996094 211.575531,267.086334 209.571594,268.932861 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M359.264435,222.435135 
	C359.292908,232.878265 359.375092,242.869873 359.275787,252.859680 
	C359.173431,263.150085 352.994049,269.293579 342.739258,269.390076 
	C334.580719,269.466858 326.418457,269.530701 318.262848,269.360291 
	C314.594818,269.283691 313.158569,270.624969 313.299316,274.315338 
	C313.495850,279.469513 313.252716,284.639069 313.362122,289.798523 
	C313.419525,292.507629 312.347321,293.865540 309.627594,293.877106 
	C309.461426,293.877808 309.295105,293.894562 309.129242,293.908875 
	C296.792023,294.974274 296.705261,294.896118 296.703888,282.473419 
	C296.701416,259.660797 296.844360,236.846603 296.591278,214.036774 
	C296.533966,208.872787 298.264099,207.489319 303.204742,207.604279 
	C316.019562,207.902451 328.846039,207.662094 341.667389,207.727997 
	C351.506226,207.778564 356.960541,212.270325 359.264435,222.435135 
M314.498840,252.095215 
	C322.601593,253.364746 330.753937,252.384766 338.879852,252.618576 
	C341.280060,252.687637 342.005859,251.087219 342.008667,249.009628 
	C342.017700,242.349792 341.985016,235.689880 342.002869,229.030075 
	C342.010010,226.359970 340.792480,225.050110 338.073212,225.065323 
	C331.080444,225.104477 324.087402,225.085739 317.094452,225.097458 
	C315.064941,225.100861 313.348083,225.615143 313.406799,228.092575 
	C313.591522,235.888718 312.702515,243.708588 314.498840,252.095215 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M383.298828,241.955048 
	C383.302063,242.946198 383.304901,243.445526 383.305725,243.944870 
	C383.319366,252.143402 383.313629,252.262512 391.244232,252.640182 
	C394.243134,252.782990 395.371918,253.937683 395.340576,256.867706 
	C395.177246,272.143372 396.939789,269.136841 383.601044,269.311493 
	C372.305664,269.459381 366.079926,263.153320 366.023102,251.753815 
	C365.926788,232.446426 366.075684,213.137146 365.865479,193.831451 
	C365.813263,189.035217 367.456482,187.468796 372.235352,187.610458 
	C384.583191,187.976471 383.259857,186.385193 383.288361,198.519943 
	C383.321960,212.834305 383.297058,227.148788 383.298828,241.955048 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M178.016022,207.754089 
	C186.376419,207.737091 186.388748,207.737091 186.391037,215.583664 
	C186.395691,231.540466 186.240356,247.499390 186.472626,263.452759 
	C186.539917,268.073792 184.988083,269.521271 180.460953,269.391327 
	C168.473923,269.047150 169.801041,270.621307 169.744064,258.700775 
	C169.675735,244.406448 169.720795,230.111572 169.723267,215.816940 
	C169.724640,207.791885 169.730560,207.791885 178.016022,207.754089 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M346.093506,308.654510 
	C348.199341,310.339264 348.336548,312.302643 348.321716,314.342590 
	C348.296387,317.829285 348.318237,321.316284 348.315460,324.803162 
	C348.308685,333.285309 341.598236,337.412506 333.587280,333.918121 
	C332.089722,333.264862 331.770538,332.157867 331.782318,330.739380 
	C331.797455,328.913727 333.016998,328.622040 334.460449,328.564026 
	C336.840820,328.468353 339.220520,328.356323 342.024231,328.232452 
	C340.781250,326.853577 339.725433,327.205627 338.802429,327.173401 
	C329.904053,326.862579 325.319702,318.741394 329.500366,310.646149 
	C330.422485,308.860596 331.993317,307.835236 333.886566,307.808044 
	C337.835876,307.751343 341.840363,307.025513 346.093506,308.654510 
M342.492218,315.106171 
	C338.984406,312.498566 335.684509,312.754028 335.108032,315.760864 
	C334.802185,317.356079 334.635498,319.253784 336.229340,320.325653 
	C337.660614,321.288239 339.478546,321.226929 341.040680,320.632263 
	C343.338104,319.757629 342.495941,317.609375 342.492218,315.106171 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M152.544189,326.461121 
	C149.335739,327.230682 148.093689,325.831818 148.071167,323.162659 
	C148.026230,317.834961 148.061569,312.506561 148.067123,307.178467 
	C148.070129,304.290436 149.532425,302.938232 152.406921,302.964417 
	C156.735580,303.003845 161.078369,302.773041 165.390137,303.048615 
	C170.422394,303.370239 172.137711,305.821472 171.998779,311.669128 
	C171.869888,317.092743 170.044174,319.100281 165.025711,319.332458 
	C164.693192,319.347839 164.353455,319.386169 164.027588,319.339813 
	C158.371826,318.535828 153.662491,319.236237 152.544189,326.461121 
M157.038818,309.267242 
	C155.301041,309.361877 154.074402,310.022644 154.459229,312.015015 
	C154.738083,313.458679 155.984100,313.591095 157.187073,313.607056 
	C158.846603,313.628998 160.506943,313.647552 162.166168,313.620239 
	C163.712326,313.594788 165.378738,313.461487 165.492798,311.466339 
	C165.615753,309.315338 163.865265,309.302551 162.355591,309.248688 
	C160.863693,309.195465 159.368484,309.234863 157.038818,309.267242 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M252.434799,319.459656 
	C248.693741,320.879944 245.141785,319.802460 241.679871,320.965057 
	C244.458206,320.965057 247.237595,320.918549 250.014496,320.981842 
	C251.794479,321.022430 253.322083,321.433350 253.350250,323.754028 
	C253.379211,326.140137 252.127441,327.021088 249.943008,327.026917 
	C248.609894,327.030487 247.274048,327.007996 245.944183,327.082245 
	C234.687805,327.710815 233.124405,326.308380 234.098328,312.965302 
	C234.335800,309.711975 236.310654,307.847382 239.680237,307.715179 
	C241.011765,307.662964 242.346085,307.670898 243.679138,307.670380 
	C253.036179,307.666748 254.545151,309.572845 252.434799,319.459656 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M297.037231,311.234558 
	C296.843323,314.833893 294.526703,314.145020 292.652435,313.817047 
	C290.261871,313.398712 287.942474,313.173401 284.799500,313.776917 
	C287.444275,315.122955 289.436249,314.581940 291.339111,314.617035 
	C295.179504,314.687897 297.254547,316.458740 297.364319,320.341187 
	C297.475891,324.286804 295.719116,326.766510 291.619934,326.969604 
	C288.641144,327.117218 285.622589,327.158661 282.665436,326.840851 
	C279.932098,326.547089 278.277100,324.808167 277.961304,321.596161 
	C281.461365,319.514313 285.250214,321.904755 289.327972,320.471893 
	C286.771027,320.353271 284.871368,320.381500 283.002777,320.154236 
	C279.119843,319.681976 277.681641,317.090820 277.757721,313.507477 
	C277.832214,309.998627 279.661194,307.508026 283.237244,307.813446 
	C287.886414,308.210541 293.403473,305.278656 297.037231,311.234558 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M258.959137,319.401672 
	C255.520447,317.228363 255.449020,314.333466 256.420471,311.299805 
	C257.485779,307.973083 260.249329,307.543793 263.261017,307.660980 
	C265.913147,307.764252 268.595245,307.570648 271.214691,307.900543 
	C273.569153,308.196991 275.423737,309.787018 275.025116,312.275635 
	C274.612640,314.850555 272.247986,314.074310 270.543213,313.776428 
	C268.239227,313.373840 265.972656,313.138824 262.732788,313.818695 
	C265.398956,315.109955 267.467560,314.620331 269.393829,314.643829 
	C273.250061,314.690918 275.211151,316.448395 275.362915,320.363159 
	C275.519440,324.400177 273.785065,326.730194 269.691223,326.957947 
	C267.043732,327.105225 264.369568,327.176636 261.730896,326.974670 
	C258.655701,326.739258 256.433105,325.339111 256.254333,321.927490 
	C258.109528,320.037201 260.145325,320.882751 262.055664,320.903168 
	C263.872314,320.922577 265.689301,320.907349 267.535339,320.669708 
	C264.862671,319.891205 261.934937,320.822937 258.959137,319.401672 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M200.893707,307.666199 
	C208.904953,307.901062 209.691803,309.065247 209.643311,319.926270 
	C209.619858,325.180817 207.582855,326.925598 201.168930,327.075806 
	C199.175690,327.122498 197.159561,327.171021 195.187820,326.935181 
	C191.958572,326.549042 190.157898,324.573486 189.809067,321.340118 
	C189.702301,320.350586 189.725723,319.345734 189.712784,318.347565 
	C189.582825,308.323914 190.240189,307.670135 200.893707,307.666199 
M198.722702,320.929962 
	C200.977005,320.837006 203.645386,321.343964 203.638702,317.780914 
	C203.635452,316.045410 204.164108,313.798615 201.551422,313.540833 
	C199.561951,313.344574 196.842026,312.379547 195.872360,314.944183 
	C195.073120,317.058105 194.273026,319.944153 198.722702,320.929962 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M169.716064,196.019989 
	C169.729080,187.815796 169.729080,187.815704 177.353226,187.816086 
	C178.518311,187.816147 179.698349,187.938278 180.845810,187.796402 
	C185.117844,187.268250 187.214066,188.823151 186.424225,193.349930 
	C186.339615,193.834824 186.410202,194.346634 186.407059,194.845947 
	C186.334503,206.410507 187.657501,204.968735 175.956955,205.262085 
	C171.156174,205.382477 169.109329,203.787506 169.706940,198.994659 
	C169.809097,198.175400 169.718491,197.332077 169.716064,196.019989 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M407.122559,269.348419 
	C403.043549,269.720978 401.613739,268.158997 401.664185,264.501617 
	C401.854919,250.673279 400.285522,253.092941 413.049103,252.599030 
	C417.721039,252.418243 419.381958,254.126312 418.888306,258.599945 
	C417.536346,270.852020 420.605652,269.210693 407.122559,269.348419 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M226.750702,327.056580 
	C225.461639,327.077148 224.630554,327.050690 223.802795,327.091522 
	C211.221985,327.712097 211.417618,324.839203 211.863586,313.088501 
	C211.950424,310.800354 213.070587,308.606873 215.366074,308.123840 
	C219.926697,307.164185 224.606903,307.548981 229.230194,307.918701 
	C230.890747,308.051483 231.184875,309.441437 231.137070,310.890076 
	C231.091293,312.276611 230.360535,313.112274 229.032822,313.192322 
	C226.717438,313.331940 224.391144,313.397156 222.072495,313.348236 
	C219.491257,313.293793 217.980270,314.111542 218.018448,317.022919 
	C218.053802,319.719116 219.166245,321.027954 221.902374,320.946045 
	C223.559464,320.896423 225.223160,320.900452 226.878098,320.988770 
	C228.856689,321.094360 231.057953,320.974670 231.208740,323.870850 
	C231.361267,326.800201 229.259140,326.887360 226.750702,327.056580 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M306.985748,320.734436 
	C307.132568,305.442719 305.194244,307.887970 320.300781,307.692230 
	C324.676361,307.635529 326.700409,309.772156 326.473419,314.191223 
	C326.311218,317.349457 326.395325,320.519928 326.346527,323.684570 
	C326.321045,325.336639 325.829895,326.689545 323.870819,326.768097 
	C321.730988,326.853851 320.921326,325.563080 320.816864,323.634705 
	C320.814819,322.136841 320.852203,320.636536 320.816864,319.138123 
	C320.751740,316.377594 321.504639,313.268829 316.882233,313.324188 
	C312.593445,313.375519 313.240967,316.248993 313.159271,318.853119 
	C313.117523,320.184998 313.135132,321.518677 313.094604,322.850616 
	C313.035797,324.782562 312.784546,326.647522 310.273254,326.757355 
	C307.839844,326.863770 307.194275,325.224121 307.058258,323.196686 
	C307.013672,322.532349 307.010254,321.865265 306.985748,320.734436 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M178.791458,325.244354 
	C175.266876,328.016388 173.430573,326.982971 173.027054,323.057251 
	C172.875381,321.581512 173.020325,320.077850 172.962036,318.589569 
	C172.476364,306.191345 176.900833,307.614960 186.051147,307.743744 
	C187.563324,307.765015 188.616455,308.494354 188.631531,310.129791 
	C188.644119,311.496246 188.314941,313.331726 186.761841,313.119507 
	C177.156677,311.807251 179.406067,318.699310 179.110168,323.868225 
	C179.091339,324.197021 179.009277,324.522186 178.791458,325.244354 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M299.683105,316.126648 
	C299.708252,312.040863 299.739929,308.422089 299.755463,304.803223 
	C299.762909,303.072357 300.362518,301.902527 302.318176,301.859833 
	C304.112640,301.820648 305.224396,302.570160 305.232269,304.449982 
	C305.260132,311.109497 305.265686,317.769226 305.232666,324.428680 
	C305.224701,326.034393 304.269470,326.870697 302.675934,326.834198 
	C301.204529,326.800537 299.986542,326.197144 299.887360,324.578705 
	C299.724579,321.922821 299.741730,319.255890 299.683105,316.126648 
z"/>
</svg>`;
